require('./firebaseConfig.js');
import firebase from 'firebase/app'
import 'firebase/firestore'
// firebase utils
const db = firebase.firestore()

// firebase collections
const customerCollection = db.collection('customers')

const addStripeUserIdToFirestoreCustomer = async (stripeId) => {
    let customerRef = customerCollection.doc(firebase.auth().currentUser.uid);
    return await customerRef.update({stripe_id: stripeId});
}

const addCustomerToFirebase = async (userDetails) => {
    return customerCollection.doc(firebase.auth().currentUser.uid).set({
        'displayName': userDetails.displayName,
        'email': userDetails.email,
        'companyName': userDetails.companyName,
        'phone': userDetails.phone,
        'stripe_id': userDetails.stripe_id || ''
    })
}

export {
    addCustomerToFirebase,
    addStripeUserIdToFirestoreCustomer
}